import React, { useState, useEffect } from 'react';

// material-ui
import { useTheme } from '@emotion/react';
import {
    Typography,
    Grid,
    Avatar,
    Chip,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@mui/material';
import useApi from 'hooks/useApi';
import UserService from 'services/UserService';

// project import
import DEFAULT_IMAGE from 'assets/images/users/default_user.png';
import { USER_TYPE } from 'store/constant';

// third party
import moment from 'moment';

const UserDetails = ({ venueUuid }) => {

    const theme = useTheme();
    const [rows, setRows] = useState([]);

    const handleSuccess = (response) => {
        setRows(response.data.rows);
    };

    const userListApi = useApi(UserService.getUserList, handleSuccess);

    useEffect(() => {
        userListApi.execute({
            filter: {
                user_type: [USER_TYPE[0].value],
                uuid_venue: [venueUuid]
            }
        });
    }, []);

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow >
                        <TableCell sx={{ pl: 3 }}>#</TableCell>
                        <TableCell >User Name</TableCell>
                        <TableCell >Email</TableCell>
                        <TableCell sx={{ textAlign: 'center' }}>Phone</TableCell>
                        <TableCell sx={{ textAlign: 'center' }}>DOB</TableCell>
                        <TableCell sx={{ textAlign: 'center' }}>City</TableCell>
                        <TableCell sx={{ textAlign: 'center' }}>Status</TableCell>
                        <TableCell sx={{ textAlign: 'center' }}>created At</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        rows.map((row, index) =>
                            <TableRow hover key={index}>
                                <TableCell sx={{ pl: 3 }}>{index + 1}</TableCell>
                                <TableCell>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item>
                                            <Avatar alt="Venue" src={row.image ? row.image : DEFAULT_IMAGE} />
                                        </Grid>
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {row.firstname} {row.lastname}
                                            </Typography>
                                            <Typography align="left" variant="subtitle2" noWrap>
                                                {row.code}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell >{row.email}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>+{row.countrycode} {row.phone}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>{row.dob ? moment(row.dob).format('DD-MM-YYYY') : ''}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>{row.loc_city}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>
                                    {
                                        row.active ? (
                                            <Chip
                                                label="Active"
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.success.light + 60,
                                                    color: theme.palette.success.dark
                                                }}
                                            />
                                        ) : (
                                            <Chip
                                                label="Inactive"
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.error.light + 60,
                                                    color: theme.palette.error.dark
                                                }}
                                            />
                                        )
                                    }
                                </TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>
                                    {row.created_at ? moment(row.created_at).format('DD-MM-YYYY HH:mm:ss') : ''}
                                </TableCell>
                            </TableRow>
                        )
                    }
                </TableBody >
            </Table >
        </TableContainer >
    )
}
export default UserDetails